export function useNavTo( _option ){
  // Quick Instruction.
  // ------ In onMounted
  // useNavTo({
  //   offset: 0,
  //   $offsetHeader: '.m-msf-nav',
  //   $offsetHeaderRatio: 0.8
  // });

  // ------ In vue template.
  // Add navTo attr to the button element.
  // Add navSection attr to the destination.

  const defaultOption = { offset: 0, $offsetHeader: false, $offsetHeaderRatio: 1 };
  const option = { ...defaultOption, ..._option };
  const $navs = document.querySelectorAll('[navTo]');
  const scrollTo = (e) => {
    const navSectionName = e.target.getAttribute('navTo');
    const offset = option.offset + ( option.$offsetHeader ? document.querySelector(option.$offsetHeader).offsetHeight * option.$offsetHeaderRatio : 0 );
    const sectionOffset = document.querySelector(`[navSection="${navSectionName}`).getBoundingClientRect().top + window.scrollY;
    window.scrollTo({
      top: sectionOffset - offset,
      behavior: 'smooth'
    });
  }
  for( const $nav of $navs) {
    $nav.addEventListener( "click", scrollTo )
  }

  // Old Way: needs add @click and call useNavTo on the all nav elements
  // const navSectionName = e.target.getAttribute('navTo');
  // const sectionOffset = document.querySelector(`[navSection="${navSectionName}`).getBoundingClientRect().top + window.scrollY;
  // window.scrollTo({
  //     top: sectionOffset - offset,
  //     behavior: 'smooth'
  // });
}
export function useNavMenu(){
  // Quick Instruction.
  // ------ In onMounted
  // useNavMenu();
  const observer = new IntersectionObserver( (entries)=>{
    entries.forEach(({ target, isIntersecting }) => {
        const navSectionName = target.getAttribute('navSection')
        if (isIntersecting) {
          for (var item of document.querySelectorAll('[navTo]')) {
            item.classList.remove('active');
          }
          document.querySelector(`[navTo="${navSectionName}"]`).classList.add('active')
        } else {
          // document.querySelector(`.m-msf-nav__item[scrollTo="#${id}"]`).classList.remove('active')
        }
      })
    }, 
    {
      threshold: 0.3,
    }
  )
  setTimeout(()=>{
    document.querySelectorAll('[navSection]').forEach((section) => {
      observer.observe(section)
    })
  }, 1000)
  // In case if observer needs to be canceled.
  // observer.disconnect();
  return observer;
}